import { Button, ButtonProps } from '@kizi/core-components';
import React from 'react';

interface MoreInfoButtonProps extends ButtonProps {
  onClick: React.MouseEventHandler;
  text: string;
}

export const MoreInfoButton = ({
  onClick,
  text,
  ...restProps
}: MoreInfoButtonProps): JSX.Element => {
  return (
    <Button variant="info" onClick={onClick} {...restProps}>
      {text}
    </Button>
  );
};
